import { AxiosResponse } from "axios";
import config from "../../../../config/config";
import ApiClient from "../../ApiClient";
import { ICreateMarkupRequest, IObjectMarkup } from "./types";

const forgeApi = new ApiClient("/Markups", config.api.baseUrl);

export const getMarkups = (token: string, objectID: string): Promise<IObjectMarkup[]> => {
    ApiClient.setAuthorizationToken(token);

    const url = `/${encodeURIComponent(objectID)}`;

    return forgeApi.get(url).then((response: AxiosResponse<IObjectMarkup[]>) => {
        return Promise.resolve(response.data);
    });
};

export const saveMarkup = (
    token: string,
    objectID: string,
    markupRequest: ICreateMarkupRequest
): Promise<IObjectMarkup> => {
    ApiClient.setAuthorizationToken(token);

    const url = `/${encodeURIComponent(objectID)}`;

    return forgeApi.post(url, markupRequest).then((response: AxiosResponse<IObjectMarkup>) => {
        return Promise.resolve(response.data);
    });
};
